module.exports = __webpack_public_path__ + "static/media/rightBg.dbf0ab72.png";